import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MessageService } from "common";
import { defaultObservableErrorHandler } from "@partner/shared/Tools";
import { ApiUrls } from "@partner/shared/SharedConstants";
import { Observable, of } from "rxjs";
import { catchError, switchMap } from "rxjs/operators";
import { CompetitorsQueryResult } from "../domain/model/competitors.model";
import { Params } from "@angular/router";
import { AppSettings } from "../../../../app.settings";

const initParams = { skip: 0, limit: 200, active: true, sort: 'value' };

@Injectable({
  providedIn: "root",
})
export class CompetitorsRemote {
  constructor(private http: HttpClient,
    private messageService: MessageService,
    private settings: AppSettings) {
    }

  getAllCompetitors(params?: Params, previous?: CompetitorsQueryResult): Observable<CompetitorsQueryResult> {
    return this.http
      .get<CompetitorsQueryResult>(
        ApiUrls(this.settings).GetCompetitors(),
        { params: params ?? initParams }
      )
      .pipe(
        switchMap(competitorsQueryResult => {
          if(previous && previous.values.length) {
            competitorsQueryResult?.values?.unshift(...previous?.values);
          }
          if (competitorsQueryResult?.values?.length == competitorsQueryResult.totalCount) {
            return of(competitorsQueryResult);
          } else {
          return this.getAllCompetitors({ ...initParams,
            skip: competitorsQueryResult.values.length,
            limit: competitorsQueryResult.totalCount },
            competitorsQueryResult
            );
          }
        }),
        catchError(
          defaultObservableErrorHandler(
            this.messageService
          )
        )
      );
  }
}
